import { connect } from 'react-redux';
import { getLastSavedTime } from 'web/store/modules/pageBuilder';
import BuilderInfo from '../components/BuilderInfo';

const mapStateToProps = state => ({
  lastSaved: getLastSavedTime(state),
});

const mapDispatchToProps = null;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BuilderInfo);
